export interface Artist {
  id: string;
  name: string;
  slug: string;
  type: 'illustrator' | 'designer' | 'writer' | 'painter';
  specialty: string;
  image: string;
  tagline: string;
}

export const artists: Artist[] = [
  {
    id: '1',
    name: 'Sarah Chen',
    slug: 'sarah-chen',
    type: 'illustrator',
    specialty: 'Editorial & Book Illustration',
    image: 'https://public.readdy.ai/ai/img_res/fe8226b7026d791f70093ec710ee40f8.jpg',
    tagline: 'Transforming stories into vivid visual narratives',
  },
  {
    id: '2',
    name: 'Marcus Rodriguez',
    slug: 'marcus-rodriguez',
    type: 'illustrator',
    specialty: 'Character Design & Animation',
    image: 'https://readdy.ai/api/search-image?query=Whimsical%20character%20design%20illustration%20with%20playful%20expressions%20and%20dynamic%20poses%2C%20featuring%20bright%20colors%20and%20cartoon%20style%2C%20clean%20white%20background%2C%20professional%20studio%20lighting%2C%20high%20quality%20digital%20art%2C%20fun%20and%20engaging%20personality&width=400&height=500&seq=ill2&orientation=portrait',
    tagline: 'Breathing life into characters that captivate audiences',
  },
  {
    id: '3',
    name: 'Yuki Tanaka',
    slug: 'yuki-tanaka',
    type: 'illustrator',
    specialty: 'Fashion & Beauty Illustration',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20fashion%20illustration%20with%20sophisticated%20style%20and%20graceful%20lines%2C%20featuring%20stylish%20figure%20in%20contemporary%20outfit%2C%20minimal%20white%20background%2C%20professional%20photography%2C%20high%20quality%2C%20modern%20fashion%20art%20with%20bold%20colors%20and%20refined%20details&width=400&height=500&seq=ill3&orientation=portrait',
    tagline: 'Capturing elegance through line and color',
  },
  {
    id: '4',
    name: 'Emma Williams',
    slug: 'emma-williams',
    type: 'illustrator',
    specialty: 'Children\'s Book Illustration',
    image: 'https://readdy.ai/api/search-image?query=Charming%20children%20book%20illustration%20with%20warm%20colors%20and%20friendly%20characters%2C%20featuring%20cute%20animals%20and%20magical%20scenes%2C%20soft%20white%20background%2C%20professional%20quality%2C%20playful%20and%20imaginative%20storytelling%20art%20with%20gentle%20textures&width=400&height=500&seq=ill4&orientation=portrait',
    tagline: 'Creating magical worlds for young imaginations',
  },
  {
    id: '5',
    name: 'David Park',
    slug: 'david-park',
    type: 'illustrator',
    specialty: 'Concept Art & Gaming',
    image: 'https://readdy.ai/api/search-image?query=Epic%20concept%20art%20illustration%20with%20dramatic%20lighting%20and%20fantasy%20elements%2C%20featuring%20heroic%20characters%20and%20mystical%20environments%2C%20clean%20background%2C%20professional%20digital%20painting%2C%20high%20quality%20game%20art%20with%20rich%20details%20and%20atmospheric%20mood&width=400&height=500&seq=ill5&orientation=portrait',
    tagline: 'Building immersive worlds from imagination',
  },
  {
    id: '6',
    name: 'Sofia Martinez',
    slug: 'sofia-martinez',
    type: 'illustrator',
    specialty: 'Advertising & Branding',
    image: 'https://readdy.ai/api/search-image?query=Bold%20advertising%20illustration%20with%20eye-catching%20graphics%20and%20modern%20commercial%20style%2C%20featuring%20vibrant%20colors%20and%20strong%20visual%20impact%2C%20white%20studio%20background%2C%20professional%20quality%2C%20contemporary%20brand%20art%20with%20clean%20composition&width=400&height=500&seq=ill6&orientation=portrait',
    tagline: 'Bold visuals that make brands unforgettable',
  },
  {
    id: '7',
    name: 'Alex Thompson',
    slug: 'alex-thompson',
    type: 'designer',
    specialty: 'Brand Identity & Logo Design',
    image: 'https://readdy.ai/api/search-image?query=Modern%20brand%20identity%20design%20showcase%20with%20minimalist%20logos%20and%20clean%20typography%2C%20featuring%20professional%20branding%20materials%20and%20color%20palettes%2C%20white%20background%2C%20high%20quality%20graphic%20design%2C%20contemporary%20visual%20identity%20system&width=400&height=500&seq=des1&orientation=portrait',
    tagline: 'Crafting identities that define brands',
  },
  {
    id: '8',
    name: 'Nina Patel',
    slug: 'nina-patel',
    type: 'designer',
    specialty: 'UI/UX & Digital Design',
    image: 'https://readdy.ai/api/search-image?query=Sleek%20user%20interface%20design%20with%20modern%20digital%20screens%20and%20interactive%20elements%2C%20featuring%20clean%20layouts%20and%20intuitive%20navigation%2C%20white%20background%2C%20professional%20quality%2C%20contemporary%20UX%20design%20with%20vibrant%20accent%20colors&width=400&height=500&seq=des2&orientation=portrait',
    tagline: 'Designing digital experiences that delight',
  },
  {
    id: '9',
    name: 'James Lee',
    slug: 'james-lee',
    type: 'designer',
    specialty: 'Packaging & Product Design',
    image: 'https://readdy.ai/api/search-image?query=Creative%20packaging%20design%20with%20innovative%20product%20presentation%20and%20attractive%20graphics%2C%20featuring%20modern%20consumer%20goods%20and%20elegant%20branding%2C%20clean%20white%20background%2C%20professional%20photography%2C%20high%20quality%20commercial%20design&width=400&height=500&seq=des3&orientation=portrait',
    tagline: 'Packaging that tells a brand story',
  },
  {
    id: '10',
    name: 'Isabella Costa',
    slug: 'isabella-costa',
    type: 'designer',
    specialty: 'Print & Editorial Design',
    image: 'https://readdy.ai/api/search-image?query=Sophisticated%20editorial%20design%20layout%20with%20elegant%20typography%20and%20magazine%20spreads%2C%20featuring%20modern%20print%20materials%20and%20artistic%20compositions%2C%20white%20background%2C%20professional%20quality%2C%20contemporary%20publication%20design&width=400&height=500&seq=des4&orientation=portrait',
    tagline: 'Elevating content through thoughtful typography',
  },
  {
    id: '11',
    name: 'Oliver Schmidt',
    slug: 'oliver-schmidt',
    type: 'designer',
    specialty: 'Motion Graphics & Animation',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20motion%20graphics%20design%20with%20animated%20elements%20and%20kinetic%20typography%2C%20featuring%20colorful%20visual%20effects%20and%20modern%20digital%20art%2C%20clean%20background%2C%20professional%20quality%2C%20contemporary%20animation%20design&width=400&height=500&seq=des5&orientation=portrait',
    tagline: 'Design in motion, stories in every frame',
  },
  {
    id: '12',
    name: 'Maya Johnson',
    slug: 'maya-johnson',
    type: 'designer',
    specialty: 'Environmental & Spatial Design',
    image: 'https://readdy.ai/api/search-image?query=Innovative%20environmental%20design%20with%20architectural%20graphics%20and%20wayfinding%20systems%2C%20featuring%20modern%20spatial%20branding%20and%20signage%2C%20white%20background%2C%20professional%20quality%2C%20contemporary%20experiential%20design&width=400&height=500&seq=des6&orientation=portrait',
    tagline: 'Shaping spaces that inspire and guide',
  },
  {
    id: '13',
    name: 'Rachel Green',
    slug: 'rachel-green',
    type: 'writer',
    specialty: 'Copywriting & Brand Voice',
    image: 'https://readdy.ai/api/search-image?query=Professional%20writer%20workspace%20with%20elegant%20notebook%20and%20creative%20writing%20tools%2C%20featuring%20modern%20desk%20setup%20and%20inspiring%20stationery%2C%20clean%20white%20background%2C%20high%20quality%20photography%2C%20contemporary%20creative%20professional%20aesthetic&width=400&height=500&seq=wri1&orientation=portrait',
    tagline: 'Words that define brands and move people',
  },
  {
    id: '14',
    name: 'Thomas Anderson',
    slug: 'thomas-anderson',
    type: 'writer',
    specialty: 'Content Strategy & SEO',
    image: 'https://readdy.ai/api/search-image?query=Digital%20content%20creation%20setup%20with%20laptop%20and%20strategic%20planning%20materials%2C%20featuring%20modern%20workspace%20and%20analytics%20charts%2C%20white%20background%2C%20professional%20photography%2C%20contemporary%20content%20marketing%20aesthetic&width=400&height=500&seq=wri2&orientation=portrait',
    tagline: 'Strategic content that drives growth',
  },
  {
    id: '15',
    name: 'Priya Sharma',
    slug: 'priya-sharma',
    type: 'writer',
    specialty: 'Technical & UX Writing',
    image: 'https://readdy.ai/api/search-image?query=Clean%20technical%20writing%20workspace%20with%20documentation%20and%20user%20guides%2C%20featuring%20modern%20computer%20setup%20and%20organized%20materials%2C%20white%20background%2C%20professional%20quality%2C%20contemporary%20technical%20communication%20aesthetic&width=400&height=500&seq=wri3&orientation=portrait',
    tagline: 'Making complex things beautifully simple',
  },
  {
    id: '16',
    name: 'Michael Brown',
    slug: 'michael-brown',
    type: 'writer',
    specialty: 'Scriptwriting & Storytelling',
    image: 'https://readdy.ai/api/search-image?query=Creative%20scriptwriting%20desk%20with%20screenplay%20pages%20and%20storytelling%20notes%2C%20featuring%20vintage%20typewriter%20and%20modern%20writing%20tools%2C%20white%20background%2C%20professional%20photography%2C%20artistic%20writer%20aesthetic&width=400&height=500&seq=wri4&orientation=portrait',
    tagline: 'Stories that captivate and inspire action',
  },
  {
    id: '17',
    name: 'Laura Kim',
    slug: 'laura-kim',
    type: 'writer',
    specialty: 'Social Media & Digital Content',
    image: 'https://readdy.ai/api/search-image?query=Modern%20social%20media%20content%20creation%20workspace%20with%20smartphone%20and%20creative%20planning%20boards%2C%20featuring%20colorful%20sticky%20notes%20and%20digital%20devices%2C%20white%20background%2C%20professional%20quality%2C%20contemporary%20digital%20marketing%20aesthetic&width=400&height=500&seq=wri5&orientation=portrait',
    tagline: 'Content that sparks conversations',
  },
  {
    id: '18',
    name: 'Daniel White',
    slug: 'daniel-white',
    type: 'writer',
    specialty: 'Editorial & Journalism',
    image: 'https://readdy.ai/api/search-image?query=Professional%20journalism%20workspace%20with%20newspapers%20and%20editorial%20materials%2C%20featuring%20modern%20laptop%20and%20research%20documents%2C%20clean%20white%20background%2C%20high%20quality%20photography%2C%20contemporary%20news%20writing%20aesthetic&width=400&height=500&seq=wri6&orientation=portrait',
    tagline: 'Journalism that illuminates and informs',
  },
  {
    id: '19',
    name: 'Clara Monet',
    slug: 'clara-monet',
    type: 'painter',
    specialty: 'Oil Painting & Landscape',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20oil%20painting%20landscape%20artwork%20with%20warm%20golden%20sunset%20colors%20and%20lush%20green%20meadows%2C%20impressionist%20style%20with%20visible%20brushstrokes%2C%20serene%20countryside%20scene%2C%20professional%20fine%20art%20quality%2C%20elegant%20composition%20with%20soft%20atmospheric%20perspective&width=400&height=500&seq=pnt1&orientation=portrait',
    tagline: 'Capturing nature\'s fleeting beauty on canvas',
  },
  {
    id: '20',
    name: 'Liam Hartwell',
    slug: 'liam-hartwell',
    type: 'painter',
    specialty: 'Abstract & Contemporary',
    image: 'https://readdy.ai/api/search-image?query=Bold%20abstract%20contemporary%20painting%20with%20vibrant%20warm%20red%20orange%20and%20gold%20colors%2C%20expressive%20brushstrokes%20and%20dynamic%20composition%2C%20modern%20art%20gallery%20quality%2C%20textured%20canvas%20with%20layered%20paint%2C%20energetic%20and%20emotional%20abstract%20expressionism&width=400&height=500&seq=pnt2&orientation=portrait',
    tagline: 'Emotions expressed through color and form',
  },
  {
    id: '21',
    name: 'Hana Yoshida',
    slug: 'hana-yoshida',
    type: 'painter',
    specialty: 'Watercolor & Botanical Art',
    image: 'https://readdy.ai/api/search-image?query=Delicate%20watercolor%20botanical%20painting%20with%20soft%20warm%20pastel%20colors%20featuring%20blooming%20flowers%20and%20leaves%2C%20refined%20Japanese-inspired%20aesthetic%2C%20gentle%20washes%20and%20precise%20details%2C%20professional%20fine%20art%20quality%2C%20elegant%20and%20serene%20composition%20on%20white%20paper&width=400&height=500&seq=pnt3&orientation=portrait',
    tagline: 'Delicate beauty found in every petal',
  },
  {
    id: '22',
    name: 'Rafael Dominguez',
    slug: 'rafael-dominguez',
    type: 'painter',
    specialty: 'Portrait & Figurative Art',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20figurative%20portrait%20painting%20with%20warm%20earth%20tones%20and%20dramatic%20chiaroscuro%20lighting%2C%20classical%20realism%20technique%20with%20modern%20sensibility%2C%20expressive%20human%20figure%20on%20canvas%2C%20professional%20fine%20art%20quality%2C%20rich%20textures%20and%20emotional%20depth&width=400&height=500&seq=pnt4&orientation=portrait',
    tagline: 'Revealing the soul through portraiture',
  },
  {
    id: '23',
    name: 'Elise Bergman',
    slug: 'elise-bergman',
    type: 'painter',
    specialty: 'Mixed Media & Collage',
    image: 'https://readdy.ai/api/search-image?query=Creative%20mixed%20media%20collage%20artwork%20with%20warm%20terracotta%20and%20gold%20tones%2C%20combining%20painted%20textures%20with%20paper%20and%20fabric%20elements%2C%20contemporary%20art%20style%20with%20layered%20composition%2C%20professional%20gallery%20quality%2C%20tactile%20and%20visually%20rich%20surface&width=400&height=500&seq=pnt5&orientation=portrait',
    tagline: 'Layering stories through texture and material',
  },
  {
    id: '24',
    name: 'Jun Takahashi',
    slug: 'jun-takahashi',
    type: 'painter',
    specialty: 'Ink Wash & East Asian Art',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20ink%20wash%20painting%20with%20warm%20sepia%20and%20charcoal%20tones%20featuring%20misty%20mountain%20landscape%2C%20traditional%20East%20Asian%20sumi-e%20technique%20with%20modern%20interpretation%2C%20flowing%20brushwork%20and%20atmospheric%20depth%2C%20professional%20fine%20art%20quality%2C%20meditative%20and%20contemplative%20composition&width=400&height=500&seq=pnt6&orientation=portrait',
    tagline: 'Ancient traditions meet modern expression',
  },
];
